import { FormControlLabel, Input, MenuItem, Select, Typography } from "@mui/material"
import { setFromEvent } from "lib/setFromEvent"
import { defaultNumberOfRecords } from "lib/@components/pagination/default-number-of-records"

export function PageSize({ take, setTake }) {
    return (
        <FormControlLabel
            label={<Typography variant="body2">Rows per page: </Typography>}
            labelPlacement="start"
            control={
                <Select
                    sx={{ mr: 2, ml: 2, fontSize: 13 }}
                    variant="standard"
                    SelectDisplayProps={{ "data-cy": "pagination-rows-per-page" }}
                    labelId="rows-per-page-label"
                    input={<Input disableUnderline />}
                    value={take}
                    onChange={setFromEvent(setTake)}
                >
                    {getPageSizeOptions()}
                </Select>
            }
        />
    )
}

function getPageSizeOptions() {
    return defaultNumberOfRecords.map(getPageSizeOption)
}

function getPageSizeOption(rowCountValue) {
    return (
        <MenuItem
            key={rowCountValue}
            value={rowCountValue}
            data-cy={`pagination-rows-per-page-option-${rowCountValue}`}
        >
            {rowCountValue}
        </MenuItem>
    )
}
